import React from 'react'
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'

import "./styles/integration-styles.scss"
import IntegrationTable from './pages/IntegrationView/IntegrationTable/IntegrationTable'
function Integration(props) {

    return (
        <section id="app-integrations" className="st-def-mar-TB">
            <Container fluid className="st-container">
                <div className="app-multipliers">
                    <div className="app-header-wrapper mb-3">
                        <p className="app-heading text-capitalize">Integration</p>
                        <p className="app-desc">Integration with API</p>
                    </div>


                    <div className="app-content-container">
                        <div className="app-card ">
                            <div className="app-card-content border st-default-rounded-block mb-3">
                                <IntegrationTable />
                            </div>
                        </div>
                    </div>
                </div>
            </Container>
        </section >
    )
}


const getDataFromStore = state => {
    return {
        currentUser: state.auth.currentUser
    };
}

// const dispatchActionsToProps = dispatch => {
//     return {
//         setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
//     }
// }

export default connect(getDataFromStore, null)(Integration)